export default "__VITE_ASSET__CwUwgCLI__"